import React from 'react'
import './cover.css'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const LARGE_NAME_FONTS = [
  "Playfair Display, serif",
  "Cinzel Decorative, serif",
];

const PhotoCover = ({onScrollClick,details,showScrollIndicator,hideScrollIndicator}) => {
  const blurredBackgroundUrl = details?.bannerImage?.url
  ? details.bannerImage.url.replace('/upload/', '/upload/w_320/')
  : '';

  const internalCss = `
    .cover-bg {
      background-image: url(${blurredBackgroundUrl});
    }
  `;

  const isLargeNameFont = LARGE_NAME_FONTS.includes(
  details?.nameFontStyle
);

const groomNameBanner=()=>{
  return(  <h3 className={`cover-name ${isLargeNameFont ? "cover-name--compact":""}`} style={{fontFamily:details.nameFontStyle}}>{ details?.groomName}</h3>)
}

const brideNameBanner=()=>{
  return( <h3 className={`cover-name ${isLargeNameFont ? "cover-name--compact":""}`} style={{fontFamily:details.nameFontStyle}}>{ details?.brideName}</h3>)
}

  return (
    <>
       <style>{internalCss}</style>
     <section className='cover photo-cover cover-animate'>
        <div className="cover-bg"></div>
        <img
         src={
    details?.bannerImage?.url
      ? details.bannerImage.url.replace('/upload/', '/upload/w_1080/')
      : ''
  }
         className='cover-bg-image'
         loading='lazy'
         srcSet={`
 ${details?.bannerImage ? details?.bannerImage.url.replace('/upload/', '/upload/w_320/') : ''} 320w,
    ${details?.bannerImage ? details?.bannerImage.url.replace('/upload/', '/upload/w_640/') : ''} 640w,
    ${details?.bannerImage ? details?.bannerImage.url.replace('/upload/', '/upload/w_1080/') : ''} 1080w,
    `}
   sizes="
    (max-width: 320px) 320px,
    (max-width: 640px) 640px,
    (max-width: 1080px) 1080px"
  alt='banner-img'
         />
        <div className={`background-overlay overlay-${details?.fontAlignment}`}></div>
       <div  className={`cover-details cover-${details?.fontAlignment}`}  style={{ color: details?.fontColor}}  >
           {details?.displayOrder==="groomFirst" ? <>
         {groomNameBanner()}
         <span   className={`cover-and ${isLargeNameFont ? "cover-and--compact":""}`}  style={{fontFamily:details.nameFontStyle}}>&</span>
          {brideNameBanner()}
           </>:<>
         {brideNameBanner()}
       <span className={`cover-and ${isLargeNameFont ? "cover-and--compact":""}`} style={{fontFamily:details.nameFontStyle}}>&</span>
       {groomNameBanner()}
           </>}
          
           
            {details?.hashtag && (
    <div className="cover-hashtag">#{details.hashtag}</div>
)}
       </div>
       
       {showScrollIndicator && (<div  className={`scroll-indicator ${ hideScrollIndicator ? "hide" : ""}`} onClick={onScrollClick}>
            <ExpandMoreIcon className='scroll-indication-icon' />
          <span>SCROLL</span>
        </div>) }
        
     </section>
       </>
  )
  

}

export default PhotoCover